

















/* General */
import Vue from 'vue'
import LowIcon from '@/assets/img/priority/low.svg'
import MediumIcon from '@/assets/img/priority/medium.svg'
import HighIcon from '@/assets/img/priority/high.svg'
import CriticalIcon from '@/assets/img/priority/critical.svg'

/* Mixins */

/* Components */
import chicklet from './chicklet.vue'

/* Helpers */

/* Data types */
import { IDynamicObject } from '@/types'
import { IPriorityLevelForSelection } from '@/api/types/response.types'

/* API */

export default Vue.extend({
  name: 'PriorityChicklet',

  components: {
    chicklet,
  },

  props: {
    priority: {
      type: Object as () => IPriorityLevelForSelection,
      default: null,
    },
    /* 'large', 'medium', 'small', 'tiny' */
    size: {
      type: String,
      default: 'tiny',
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    iconStatusList(): IDynamicObject {
      return {
        low: LowIcon,
        medium: MediumIcon,
        high: HighIcon,
        critical: CriticalIcon,
      }
    },
    selectedIcon(): string {
      if (this.priority.name) {
        return this.iconStatusList[this.priority.name.toLowerCase()]
      }
      return ''
    },
    showIcon(): boolean {
      return this.selectedIcon && !this.hideIcon
    },
  },
})
